<div id="page-not-found-wrapper">
  <div id="page-not-found-message">
    <h1>404</h1>
    <h5>Page Not Found</h5>
    <p style="text-align: center">
      Unfortunately, the page you are looking for doesn't exist. Check that the link you used was correct.
    </p>
  </div>
</div>
